import React from 'react';
import FormCard from '../../../../../../components/FormCard';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import TextBox from '../../../../../../components/TextBox.jsx';
import DrugSearchInputClean from '../../DrugSearchInputClean.jsx';
import styles from '../../../../css/inventoryItemDetail.module.css';

export default function FSHeaderRow({ f, errors = {}, categories = [], departmentName, onItemSelect, onBarcodeSelect }) {
  return (
    <FormCard>
      <FormRow className={styles.row}>
        <Field label="Item Name" error={errors?.name}>
          <DrugSearchInputClean
            id="frontshop-item-name"
            initialValue={f.productName}
            placeholder="Search item name"
            productType="Item"
            department={departmentName}
            dropdownOnly={true}
            onInputChange={value => {
              f.setProductName(value);
            }}
            onSelect={medication => onItemSelect(medication, { f, categories })}
          />
        </Field>
        <Field label="Barcode" error={errors?.barcode}>
          <DrugSearchInputClean
            id="frontshop-barcode"
            initialValue={f.barcode}
            placeholder="Search barcode"
            numericOnly
            productType="Item"
            department={departmentName}
            dropdownOnly={true}
            getDisplayValue={medication => (medication?.barcode ? String(medication.barcode) : '')}
            onInputChange={value => {
              f.setBarcode(value);
            }}
            onSelect={medication => onBarcodeSelect(medication, { f, categories })}
          />
        </Field>
        <Field label="Invoice Number" error={errors?.invoicenumber}>
          <TextBox
            id="frontshop-invoice"
            name="invoiceNumber"
            value={f.invoiceNumber}
            onChange={(e) => f.setInvoiceNumber(e.target.value)}
            placeholder="Invoice number"
            className={styles.tallInput}
          />
        </Field>
      </FormRow>
    </FormCard>
  );
}
